import PropTypes from "prop-types";
import { useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { fetchSEOConfig } from "../store/slices/app-slice";

const SEO = ({ title, titleTemplate, description, keywords = "Cupping Room" }) => {
    const dispatch = useDispatch();
    const { site_meta_title, site_meta_description, site_meta_keywords } = useSelector((state) => state.app);

    useEffect(() => {
        dispatch(fetchSEOConfig());
    }, [dispatch]);

    const defaultTitle = `${title} | ${titleTemplate}`;
    const customTitle = `${site_meta_title} | ${titleTemplate}`;

    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8" />
                <title>
                    {site_meta_title ? customTitle : defaultTitle}
                </title>
                <meta name="description" content={site_meta_description ? site_meta_description : description} />
                <meta name="keywords" content={keywords ? keywords : site_meta_keywords} />
            </Helmet>
        </HelmetProvider>
    );
};

SEO.propTypes = {
    title: PropTypes.string,
    titleTemplate: PropTypes.string,
    description: PropTypes.string,
}

SEO.defaultProps = {
    title: "Cupping Room",
    titleTemplate: "Product Page",
    description: "Cupping Room",
};

export default SEO;